import {BaseLayerSelector} from "base/component/geo";
import useTheme from "@mui/material/styles/useTheme";
import {SisbagalMapDownloadPdfAction, SisbagalMapDownloadPngAction} from "sisbagal/map";

import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import Grid from "@mui/material/Grid";
import ButtonGroup from "@mui/material/ButtonGroup";
import SisbagalBufferSelector from "./SisbagalBufferSelector";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

const SisbagalMapActions = ({
    expanded = true,
    onToggle,
    contentId,
    generateMapAsPng,
    getMapAsPngDimensions,
    handleDownloadMapAsPng,
    entityData = {},
    showDownloadPdfAction = false,
}) => {
    const theme = useTheme();

    return (
        <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{
                bgcolor: theme.palette.secondary.light,
                borderBottom: `1px solid ${theme.palette.secondary.main}`,
                minHeight: "50px",
            }}
        >
            <ButtonBase
                onClick={onToggle}
                aria-expanded={expanded}
                aria-controls={contentId}
                sx={{
                    px: 1,
                    minHeight: 50,
                    gap: 1,
                    flex: 1,
                    justifyContent: "flex-start",
                }}
            >
                <Typography variant="h6">Capas</Typography>
            </ButtonBase>
            <Box sx={{display: "flex", alignItems: "center"}}>
                <ButtonGroup variant="outlined" aria-label="map button group">
                    <Divider orientation="vertical" flexItem />
                    <BaseLayerSelector />
                    <Divider orientation="vertical" flexItem />
                    <SisbagalBufferSelector />
                    {showDownloadPdfAction && (
                        <>
                            <Divider orientation="vertical" flexItem />
                            <SisbagalMapDownloadPdfAction
                                generateMapAsPng={generateMapAsPng}
                                getMapAsPngDimensions={getMapAsPngDimensions}
                                entityData={entityData}
                            />
                        </>
                    )}
                    <Divider orientation="vertical" flexItem />
                    <SisbagalMapDownloadPngAction
                        onDownloadMapAsPng={handleDownloadMapAsPng}
                    />
                </ButtonGroup>
                <ButtonBase
                    onClick={onToggle}
                    aria-hidden="true"
                    tabIndex={-1}
                    sx={{px: 1, minHeight: 50}}
                >
                    {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </ButtonBase>
            </Box>
        </Grid>
    );
};

export default SisbagalMapActions;
